import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import classes from './ManualAttendance.module.scss';
import BreadCrumbs from './../../utilities/BreadCrumb/BreadCrumb';
import ManualAttendanceForm from './ManualAttendanceForm';
import ManualAttedanceList from './ManualAttedanceList';

const ManualAttendance = () => {
    const data = JSON.parse(localStorage.getItem('data'));
    const navigate = useNavigate()
    const [showAttList, setShowAttList] = useState({
        Ap: true,
        A: false,
        R: false,
        P: false
    })

    const [applied , setApplied] = useState(false)

    useEffect(() => {
        if(data !==null){
            if(data.usr_boss ===null){
                toast("You've no reporting officer assigned, kindly contact your HR Department", {
                    icon: '❗',
                    duration: 4500
                });
                navigate('/dashboard/home')
            }
        }
    }, [])



    const handleClick = (type) => {
        switch (type) {
            case "Ap": {
                return setShowAttList({ Ap: true, A: false, R: false, P: false })
            }
            case "A": {
                return setShowAttList({ Ap: false, A: true, R: false, P: false })
            }
            case "R": {
                return setShowAttList({ Ap: false, A: false, R: true, P: false })
            }
            case "P": {
                return setShowAttList({ Ap: false, A: false, R: false, P: true })
            }
            default: {
                return;
            }
        }
    }

    

    useEffect(()=>{
    if(applied === true){
            handleClick("P")
        }
    },[applied])


    return (
        <>
            <BreadCrumbs name="Manual Attendance" />
            <div className={classes.Container}>
                <div className={classes.ContainerDiv}>

                    <div className={classes.Tabs}>
                        <span className={showAttList.Ap ? classes.Active : ""} onClick={() => { handleClick("Ap") ; setApplied(false) }}><p>Apply</p></span>
                        <span className={showAttList.A ? classes.Active : ""} onClick={() => { handleClick("A") }}><p>Approved</p></span>
                        <span className={showAttList.R ? classes.Active : ""} onClick={() => { handleClick("R") }}><p>Rejected</p></span>
                        <span className={showAttList.P ? classes.Active : ""} onClick={() => { handleClick("P") }}><p>Pending</p></span>
                    </div>

                    <div style={{ overflowY: "scroll", padding: "0 20px 0px" }}>
                        {showAttList.Ap && <ManualAttendanceForm applySuccess={setApplied}/>}
                        {showAttList.A && <ManualAttedanceList listType="A" />}
                        {showAttList.R && <ManualAttedanceList listType="R" />}
                        {showAttList.P && <ManualAttedanceList listType="P" />}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManualAttendance
